import moment from 'moment'
import { myBase64Image } from '../constants/logo-excel';
const ExcelJS = require('exceljs');

moment.locale("en");

export const exportExcel = async (headers, codes, docName, columnNames, docType) => {
  //console.log('export excel - Excel codes: ', codes)
  let data = []
  const workbook = new ExcelJS.Workbook();
  workbook.addWorksheet("sheet1");
  const worksheet = workbook.getWorksheet("sheet1");

  /* const cabeceras = [
    'Fecha',
    '# Documento',
    'Transacción',
    'Concepto',
    'Tipo',
    'Valor',
    'Saldo'
  ]; */

  const cabeceras = headers;

  const imageId2 = workbook.addImage({
    base64: myBase64Image,
    extension: 'png',
  });

  if (docType===1){
    worksheet.addImage(imageId2, 'C1:E3');
    worksheet.mergeCells('A1:G3');
  }else if (docType===2){
    worksheet.addImage(imageId2, 'C1:C3');
    worksheet.mergeCells('A1:E3');
  }else if (docType===3){
    worksheet.addImage(imageId2, 'B1:E3');
    worksheet.mergeCells('A1:F3');
  }else if (docType===4){
    worksheet.addImage(imageId2, 'D1:E3');
    worksheet.mergeCells('A1:G3');
  }


  worksheet.views = [
    { state: 'worksheet', zoomScale: 127, }
  ];

  const fuenteHoja = 'Calibri';
  const cabeceraColorHoja = '2E2858';
  const tamanoContenido = 12;
  const rowHeader = worksheet.addRow(
    cabeceras
  );

  var borderStyle = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" }
  };

  var borderStyleHeader = {
    left: { style: "thin", color: { argb: 'ffffff' } },
    right: { style: "thin", color: { argb: 'ffffff' } }
  };

  rowHeader.eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: cabeceraColorHoja },
      bgColor: { argb: '' }
    };
    cell.font = {
      size: tamanoContenido,
      bold: true,
      color: { argb: 'ffffff' },
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    };
    cell.border = borderStyleHeader;
  });

  columnNames.map(row => (
    data.push({ header: "", key: row })
  ))
  //console.log(data)

  worksheet.columns = data;
  //[
    /* for (let index = 0; index < array.length; index++) {
      { header: "", key: columnNames[0] },

    } */

    /* columnNames.map(row => (
      // console.log('columna: ', row)
      ({ header: "", key: row }),
    )) */
    /* { header: "", key: codes.h }

    { header: "", key: "fecha", style: { font: { name: 'Calibri' }, fontStyle: { name: 'Regular' }, size: { name: 10 } } },
    { header: "", key: "documento" },
    { header: "", key: "transaccion" },
    { header: "", key: "concepto" },
    { header: "", key: "tipoMovimiento" },
    { header: "", key: "valor" },
    { header: "", key: "saldo" }, */
  //];


  if (docType===1){
    for (let i = 1; i < worksheet.actualColumnCount; i++) {
      if (i === 3) { worksheet.getColumn(i).width = 47; }
      else { worksheet.getColumn(i).width = 10; }
    }
  }else if (docType===2){
    for (let i = 1; i < worksheet.actualColumnCount; i++) {
      if (i === 3) { worksheet.getColumn(i).width = 47; }
      else { worksheet.getColumn(i).width = 10; }
    }
  }else if (docType===3){
    for (let i = 1; i < worksheet.actualColumnCount; i++) {
      if (i === 2) { worksheet.getColumn(i).width = 15; }
      else { worksheet.getColumn(i).width = 10; }
    }
  }else if (docType === 4) {
  const customWidths = {
    1: 11,
    2: 20,
    3: 37,
    6: 47,
    5: 27,
    7: 47,
  };

  for (let i = 1; i <= worksheet.actualColumnCount; i++) {
    const width = customWidths[i] || 10; // si no está en el mapa, ancho default 10
    worksheet.getColumn(i).width = width;
  }
}


  codes.forEach((value) => {
    worksheet.addRow(value).eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = {
        name: fuenteHoja,
        size: tamanoContenido,
      };
      cell.border = borderStyle;
    })
  })

  const uint8Array = await workbook.xlsx.writeBuffer()
  const blob = new Blob([uint8Array], { type: "application/octet-binary" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = docName + ".xlsx";
  a.click();
  a.remove();
}
